// export const API_URL = 'http://localhost:3011';
// export const API_URL = 'http://10.46.84.32:3011';
export const API_URL = "https://srv547457.hstgr.cloud:3011";//3011";
export const API_URL_UPLOADS = "https://srv547457.hstgr.cloud:3020";//3020";

// Google Maps API Configuration
export const GOOGLE_MAPS_API_KEY = "AIzaSyDZG_3GglukjKo0k6rd9ckpoxX6XCOElVo";

// Toast Configuration
export const TOAST_CONFIG = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};
